import { render, staticRenderFns } from "./RoutineBlockItem.vue?vue&type=template&id=04ce2f05&scoped=true"
import script from "./RoutineBlockItem.vue?vue&type=script&lang=js"
export * from "./RoutineBlockItem.vue?vue&type=script&lang=js"
import style0 from "./RoutineBlockItem.vue?vue&type=style&index=0&id=04ce2f05&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ce2f05",
  null
  
)

export default component.exports